// Responses

export const errorResponseSettingsFetch = 'Settings fetch failed; Invalid parameters.';
export const errorResponseSettingsUpdate = 'Settings update failed; invalid data.';

// Internal Errors

export const errorMessageSettingsSettingNotFound = 'Setting not found.';
export const errorMessageSettingsUploadFiles = 'Upload settings files failed.';
export const errorMessageSettingsUpdate = 'Update settings failed.';
export const errorMessageNoColours = 'No colours found.';
